import axios from 'axios';
import bearerTokenHeader from 'components/api-authorization/bearerToken';

export interface IEppComponent {
  eppComponentID: number;
  name: string;
  eppTypeID: number;
  eppDiameterID: number;
  eppMaterialID: number;
}

export const getEppComponents = async () => {
  const config = await bearerTokenHeader();
  const response = await axios.get('api/EppComponent', config);
  return response.data;
};
